var map = {
	"./Icon_Favorite_Airplane.svg": 72427,
	"./Icon_Favorite_Bus.svg": 40909,
	"./Icon_Favorite_Home.svg": 39092,
	"./Icon_Favorite_Office_School.svg": 57448,
	"./Icon_Favorite_Ribbon.svg": 75557,
	"./Icon_Favorite_Ribbon_Lighting.svg": 71852,
	"./Icon_Favorite_Ship.svg": 98815,
	"./Icon_Favorite_Train.svg": 92565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;